export const messageStatuses = {
  sent: 1,
  read: 2,
  sending: 3,
  error: 4,
};

export const enterCode = 13;

export const limit = 20;
